import { ReactNode, useEffect } from "react";
import keycloak from "./keycloak";
import { useDispatch } from "react-redux";
import { setCredentials, setPermissions } from "../stores/AuthSlice";
import { reconnectStomp } from "../utils/stompClient";
import { getMyPermissions } from "../services/MePermissionService";

const loadPermissions = (dispatch: ReturnType<typeof useDispatch>) => {
  getMyPermissions()
    .then((res) => dispatch(setPermissions(res.permissions ?? [])))
    .catch(() => dispatch(setPermissions([])));
};

type Props = {
  children: ReactNode;
};

const KeycloakProvider = ({ children }: Props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    let mounted = true;

    keycloak
      .init({
        onLoad: "check-sso",
        flow: "standard",
        pkceMethod: "S256",
        checkLoginIframe: false,
      })
      .then((auth: any) => {
        if (auth && mounted) {
          const token = keycloak.token!;
          const username =
            keycloak.tokenParsed?.preferred_username || "unknown";
          const roles = keycloak.tokenParsed?.realm_access?.roles || [];
          const userId = keycloak.tokenParsed?.sub as string;
          dispatch(setCredentials({ token, roles, username, userId }));
          loadPermissions(dispatch);

          keycloak.onTokenExpired = () => {
            keycloak
              .updateToken(0)
              .then((refreshed: string) => {
                if (refreshed) {
                  dispatch(
                    setCredentials({
                      token: keycloak.token!,
                      roles: keycloak.tokenParsed?.realm_access?.roles || [],
                      username:
                        keycloak.tokenParsed?.preferred_username || "unknown",
                      userId: keycloak.tokenParsed?.sub as string,
                    })
                  );
                  loadPermissions(dispatch);
                  reconnectStomp();
                } else {
                  keycloak.login();
                }
              })
              .catch((err: string | undefined) => {
                console.error("Token refresh error:", err);
                keycloak.login();
              });
          };
        } else {
          if (!window.location.pathname.includes("/public/")) {
            keycloak.login();
          }
        }
        // *** KHÔNG CẦN else keycloak.login() ở đây ***
      })
      .catch((err: any) => {
        console.error("Keycloak init error:", err);
      });

    return () => {
      mounted = false;
    };
  }, [dispatch]);

  return <>{children}</>;
};

export default KeycloakProvider;
